// src/rtkQuery/features/services/orders/ordersApi.slice.ts
import { baseApi } from '@/rtkQuery/features/services/baseApi';
import { ORDERS_ENDPOINTS } from '@/rtkQuery/config/ordersApi.config';
import type { OrderApiItem } from '@/rtkQuery/features/models/orders.model';
import type {
  CancelOrderRequest,
  CancelOrderResponse,
} from '@/rtkQuery/features/models/cancelOrder.model';

export const ordersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOrdersForPatient: builder.query<OrderApiItem[], { page?: number; pageSize?: number }>({
      query: ({ page = 1, pageSize = 200 }) => ({
        url: `${ORDERS_ENDPOINTS.GET_ORDERS_FOR_PATIENT}?page=${page}&pageSize=${pageSize}`,
        method: 'GET',
      }),
      providesTags: ['OrderHistory'],
    }),

    cancelOrder: builder.mutation<CancelOrderResponse, CancelOrderRequest>({
      query: (body) => ({
        url: ORDERS_ENDPOINTS.POST_CANCEL_ORDER,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['OrderHistory'],
    }),
  }),
  overrideExisting: false,
});
export const {
  useGetOrdersForPatientQuery,
  useLazyGetOrdersForPatientQuery,
  useCancelOrderMutation,
} = ordersApi;
